import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { IceNavService } from '../../../../icemedx-lib/src/components/ice-nav/ice-nav.service';
import { IcepanelComponent } from '../../../../icemedx-lib/src/components/icepanel/icepanel.component';
import { IcepanelContainerComponent } from '../../../../icemedx-lib/src/components/icepanel/icepanelcontainer.component';
import { iceColumnDefinition, IcecontrolSettings, IcepanelcontainerSettings } from '../../../../icemedx-lib/src/components/models/icesettings';
import { userTypes } from '../../../../icemedx-lib/src/login/login.config';
import { LoginService } from '../../../../icemedx-lib/src/login/login.service';
import { claimbucket } from '../../../../icemedx-lib/src/models/accounting/claim/claimbucket';
import { claimbucketindex } from '../../../../icemedx-lib/src/models/accounting/claim/claimbucketindex';
import { claimindex } from '../../../../icemedx-lib/src/models/accounting/claim/claimindex';
import { superbillcharges } from '../../../../icemedx-lib/src/models/accounting/medservice/superbillcharges';
import { IIceEntity } from '../../../../icemedx-lib/src/models/core/IceEntity';
import { basecode } from '../../../../icemedx-lib/src/models/ehr/subs/basecode';
import { IceTypes } from '../../../../icemedx-lib/src/models/icetypes';
import { AccountingService } from '../../../../icemedx-lib/src/services/accounting/accounting.service';
import { DomainService } from '../../../../icemedx-lib/src/services/domain/domain.service';
import { Iceutility } from '../../../../icemedx-lib/src/services/iceutility';
import { MedicalcodesService } from '../../../../icemedx-lib/src/services/medicalcodes/medicalcodes.service';
import { MessageService } from '../../../../icemedx-lib/src/services/message/message.service';
import { PatientService } from '../../../../icemedx-lib/src/services/patient/patient.service';
import { PayerService } from '../../../../icemedx-lib/src/services/payer/payer.service';
import { PharmacyService } from '../../../../icemedx-lib/src/services/pharmacy/pharmacy.service';
import { ProviderService } from '../../../../icemedx-lib/src/services/provider/provider.service';
import { VendorService } from '../../../../icemedx-lib/src/services/vendor/vendor.service';
import { AppService } from '../app.service';
import { ServicechargeHistoryComponent, ServiceViews } from '../servicechargehistory/servicechargehistory.component';
import { BreadcrumbService } from '../../../../icemedx-lib/src/services/breadcrumb/breadcrumb.service';

@Component({
  selector: 'app-claimshistory',
  templateUrl: '../servicechargehistory/servicechargehistory.component.html', //claimshistory.component.html
  styleUrls: ['./claimshistory.component.scss'],
  providers: [AppService, IceNavService, IcepanelComponent, IcepanelContainerComponent]
})
export class ClaimshistoryComponent extends ServicechargeHistoryComponent implements OnInit {

  constructor(appSvc: AppService,
    navSvc: IceNavService,
    domainSvc: DomainService,
    accSvc: AccountingService,
    loginSvc: LoginService,
    router: Router,
    vendorSvc: VendorService,
    proSvc: ProviderService,
    pharmSvc: PharmacyService,
    payerSvc: PayerService,
    patSvc: PatientService,
    codeSvc: MedicalcodesService,
    dialog: MatDialog,
    activatedRoute: ActivatedRoute,
    breadcrumbSvc: BreadcrumbService) {
      super(appSvc,
        navSvc,
        domainSvc,
        accSvc,
        loginSvc,
        router,
        vendorSvc,
        proSvc,
        pharmSvc,
        payerSvc,
        patSvc,
        codeSvc,
        dialog,
        activatedRoute, breadcrumbSvc);
  }

  onActiveRoute(next): void {
    if (this.currentView == ServiceViews.ViewByPayerBucket) {
      this.searchPayerBucket();
    }
    else {
      if (this.disableSearchButton() == false)
        this.searchClaims();
    }
  }

  ngOnInit() {
    this.getAppService().refreshMenus();

    // get the breadcrumbs to see if there's a patient in the YARD
    let data: any = this.breadcrumbService.getYardData();
    if (Iceutility.isdefined(data.account) && Iceutility.isdefined(data.patientName)) {
      this.setContextFromBreadcrumb(data.account, data.patientName);
    }
  }

  getBreadCrumTitle(): string {
    return "Claims History";
  }

  getDefaultView(): ServiceViews {
    return ServiceViews.ViewByClaim;
  }

  getViewOptions(): any[] {
    return [
      { name: "Claims by Payer Buckets", value: ServiceViews.ViewByPayerBucket },
      { name: "List of Claims", value: ServiceViews.ViewByClaim }
    ];
  }

  viewSetup(dat: IIceEntity[], feature: userTypes.USER_FEATURES): IcepanelcontainerSettings {
    super.setAddButton(false);
    let setup: IcepanelcontainerSettings = super.viewSetup(dat, feature);
    if (setup != null) {
      try {
        // Override control creation here
      }
      catch (e) {
        console.log(e);
      }
    }
    return setup;
  }

  onGetColumnDefinition(): iceColumnDefinition[] {
    if (ServiceViews.ViewByPayerBucket == this.currentView) {
      return [
        new iceColumnDefinition("created", "Created On", false, false,
          new IcecontrolSettings("icelabel", { width: "75px" }, null, null)),
        new iceColumnDefinition("claim_bucket_num", "Claim Bucket No.", false, false,
          new IcecontrolSettings("icelabel", { width: "75px" }, null, null)),
        new iceColumnDefinition("payer_name", "Payer", false, false,
          new IcecontrolSettings("icelabel", { width: "75px" }, null, null)),
        new iceColumnDefinition("patient_name", "Patient", false, false,
          new IcecontrolSettings("icelabel", { width: "75px" }, null, null)),
        new iceColumnDefinition("to_trans_account_text", "Network ID", false, false,
          new IcecontrolSettings("icelabel", { width: "75px" }, null, null)),
        new iceColumnDefinition("bill_status_text", "Status", false, false,
          new IcecontrolSettings("icelabel", { width: "75px" }, null, null)),
        new iceColumnDefinition("last_message_text", "Outbound Message", false, false,
          new IcecontrolSettings("icelabel", { width: "75px" }, null, null)),
        new iceColumnDefinition("total_claim_charge_amount", "Total", false, false,
          new IcecontrolSettings("icelabel", { width: "75px" }, null, null)),
        new iceColumnDefinition("QuickActions", "", false, false),
        new iceColumnDefinition("superbill_charges_index_key", "superbill_charges_index_key", false, true),
        new iceColumnDefinition("superbill_charges_key", "superbill_charges_key", true),
      ];
    }

    return [
      new iceColumnDefinition("date_required", "Svc. Start Date", false, false,
        new IcecontrolSettings("icelabel", { width: "74px" }, null, null)),
      new iceColumnDefinition("end_date_required", "End Date", false, false,
        new IcecontrolSettings("icelabel", { width: "75px" }, null, null)),
      new iceColumnDefinition("code", "Code", false, false,
        new IcecontrolSettings("icelabel", { width: "50px" }, null, null)),
      new iceColumnDefinition("service_description", "Claim Description", false, false,
        new IcecontrolSettings("icelabel", { width: "125px" }, null, null)),
      new iceColumnDefinition("trans_account", "Network ID", false, true,
        new IcecontrolSettings("icelabel", { width: "75px" }, null, null)),
      new iceColumnDefinition("total_amount", "Total", false, false,
        new IcecontrolSettings("icelabel", { width: "50px" }, null, null)),
      new iceColumnDefinition("amountPaid", "Paid", false, false,
        new IcecontrolSettings("icelabel", { width: "50px" }, null, null)),
      new iceColumnDefinition("cobAmounts", "COB Amounts", false, false,
        new IcecontrolSettings("icelabel", { width: "50px" }, null, null)),
      new iceColumnDefinition("amountDue", "Due", false, false,
        new IcecontrolSettings("icelabel", { width: "50px" }, null, null)),
      new iceColumnDefinition("QuickActions", "", false, false),
      new iceColumnDefinition("claim_key", "claim_key", false, true),
      new iceColumnDefinition("medical_service_key", "medical_service_key", true),
    ];
  }

  onGetActionItems(): any[] {
    if (ServiceViews.ViewByBucket == this.currentView) {
      return [IceTypes.recordQuickActionViewBucket,
      IceTypes.recordQuickActionViewBalance,
      IceTypes.recordQuickActionRemove];
    }
    return [
      IceTypes.recordQuickActionEdit,
      IceTypes.recordQuickActionViewBucket,
      IceTypes.recordQuickActionViewBalance];
  }

  onGetData(originalData: IIceEntity[]): any[] {
    return originalData;
  }

  getAllStatuses(): any[] {
    let ary = MessageService.getAccountItemStatues();
    ary.push({ value: -1, name: "All" })
    return ary;
  }

  searchPayerBucket() {
    this.enableTableSecondRow(0, false);
    this.refreshTableData([]);

    let domType = this.domainTypeCtrl.getFormControl().value;
    let domval = this.domainCtrl.getFormControl().value;
    let fromDt = this.fromDateCtrl.getFormControl().value;
    let toDt = this.toDateCtrl.getFormControl().value;
    let status = this.statusCtrl.getFormControl().value;
    let dom = "";
    try {
      let domObj = JSON.parse(domval);
      if (domObj != null && domObj.length > 0) {
        dom = domObj[0].value;
        this.loadResponsibleParties(domType, dom, domObj[0].name);
      }
    }
    catch (e) {
      dom = "";
    }

    let appSvc = this.getAppService();
    let curAct = appSvc.getCurrentAccount();
    let curActType = appSvc.getCurrentAccountType();
    this.getAccountingService().getClaimBuckets(curAct, curActType, dom, domType, Iceutility.GetDateText(fromDt, '-', false), Iceutility.GetDateText(toDt, '-', false), "CREATED", status).subscribe(
      data => {
        if (data == null || data.length == 0) {
          this.refreshTableData([]);
          return;
        }

        let buckets: claimbucketindex[] = <claimbucketindex[]>data;

        let datasrc = [];
        for (let i = 0; i < buckets.length; i++) {
          let tempidx: claimbucketindex = buckets[i];
          if (tempidx == null) continue;

          let createdate = Iceutility.isTextDateTime(tempidx.created) ? Iceutility.getDateTextEx(tempidx.created) : Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(tempidx.created));
          let modifieddate = Iceutility.isTextDateTime(tempidx.modified) ? Iceutility.getDateTextEx(tempidx.modified) : Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(tempidx.modified));
          tempidx.created = createdate;
          tempidx.modified = modifieddate;
          tempidx["claim_bucket_num"] = tempidx.claim_bucket_key.substr(0, 9) + "...";
          tempidx["to_trans_account_text"] = tempidx.to_trans_account;
          tempidx["to_account_type_text"] = DomainService.getDomainType(Iceutility.toLong(tempidx.to_account_type));
          tempidx["bill_status_text"] = MessageService.getStatus(Iceutility.toLong(tempidx.trans_status), IceTypes.SourceType.srcStatement);
          if (tempidx.last_message_key.length > 0) {
            this.getCodeService().getCodes("DATETIME_CODE", "", tempidx.last_message_date, "").subscribe(
              data => {
                if (data && data.length > 0) {
                  let bc: basecode = data[0];
                  let lastmsgdate = Iceutility.GetLocalDate(bc.title).toLocaleString();
                  let outboundmsg = MessageService.getStatus(Iceutility.toLong(tempidx.last_message_status), IceTypes.SourceType.srcStatement) + " on " + lastmsgdate;
                  if (tempidx.last_message_log.length > 0) outboundmsg += ", " + tempidx.last_message_log;
                  tempidx["last_message_text"] = outboundmsg;
                }
              },
              error => {
                console.log(JSON.stringify(this.getDomainService().getLastErrors()));
              });

          }
          datasrc.push(tempidx);

          tempidx["payer_name"] = tempidx.claim_to;
          tempidx["patient_name"] = tempidx.claim_from;
        }

        this.refreshTableData(data);
      }, error => {
        this.refreshTableData([]);
        console.log(JSON.stringify(this.getDomainService().getLastErrors()));
      });
  }

  searchClaims() {
    this.enableTableSecondRow(0, true);
    this.refreshTableData([]);
    this.currentCharge = null;
    this.currentBucket = null;
    this.currentChargeCaption = "Add Service Charge";
    this.currentBucketChargeList = [];
    this.currentChargeHistory.resetHistoryData();
    this.responsibleParties = [];

    let domType = this.domainTypeCtrl.getFormControl().value;
    let domval = this.domainCtrl.getFormControl().value;
    let fromDt = this.fromDateCtrl.getFormControl().value;
    let toDt = this.toDateCtrl.getFormControl().value;
    let keywd = this.keywordCtrl.getFormControl().value;
    let code = this.codeCtrl.getFormControl().value;
    let status = this.statusCtrl.getFormControl().value;
    let appSvc = this.getAppService();
    let dom = "";
    try {
      let domObj = JSON.parse(domval);
      if (domObj != null && domObj.length > 0) {
        dom = domObj[0].value;
        this.loadResponsibleParties(domType, dom, domObj[0].name);
      }
    }
    catch (e) {
      dom = "";
    }

    let curAct = appSvc.getCurrentAccount();
    let curActType = appSvc.getCurrentAccountType();
    keywd = !Iceutility.isdefined(keywd) ? "" : keywd;
    code = !Iceutility.isdefined(code) ? "" : code;

    this.getAccountingService().getClaims(curAct, curActType, dom, domType, Iceutility.GetDateText(fromDt, '-', false), Iceutility.GetDateText(toDt, '-', false), keywd, code, status).subscribe(
      data => {
        if (data == null || data.length == 0) {
          this.refreshTableData([]);
          return;
        }
        let svcs: claimindex[] = <claimindex[]>data;
        let datasrc = [];
        let datasrcMap = {};

        for (let i = 0; i < svcs.length; i++) {
          let tempidx: claimindex = svcs[i];
          if (tempidx == null) continue;
          if (Iceutility.isStringUndefinedNullOrEmpty(tempidx.claim_bucket_key)
            || Iceutility.isStringUndefinedNullOrEmpty(tempidx.claim_key)
            || Iceutility.isStringUndefinedNullOrEmpty(tempidx.medical_service_key)) {
            debugger;
            //this.deleteTheseServices.push(tempidx);
            continue;
          }

          let svcRec = null;
          if (datasrcMap[tempidx.medical_service_key] == null) {
            svcRec = {
              medical_service_key: tempidx.medical_service_key,
              date_required: tempidx.date_required,
              end_date_required: tempidx.end_date_required,
              code: tempidx.code,
              service_description: tempidx.service_description,
              inc_coa_type: tempidx.inc_coa_type,
              trans_status: tempidx.trans_status,
              total_amount: tempidx.total_amount,
              subscriber_key: tempidx.subscriber_key,
              coverage_key: tempidx.coverage_key,
              payer_key: tempidx.payer_key,
              claim_bucket_key: tempidx.claim_bucket_key,
              claim_key: tempidx.claim_key,
              second_row_control: new IcecontrolSettings("medical_service_key" + tempidx.medical_service_key, {}, null, null, "", "History")
                .setReadonly(true)
            };

            datasrc.push(svcRec);
            datasrcMap[tempidx.medical_service_key] = svcRec;
            this.updateServiceRecord(svcRec, true, curActType, curAct, domType, dom);
          }
          else {
            svcRec = datasrcMap[tempidx.medical_service_key];
          }

          let svcSecondRowCtrl: IcecontrolSettings = svcRec["second_row_control"];
          let secondRows = svcSecondRowCtrl.getOptions();
          let datesToConvert = [tempidx.claim_date];
          if (tempidx.last_message_key.length > 0) {
            datesToConvert.push(tempidx.last_message_date);
          }

          this.getCodeService().getCodes("DATETIME_CODE", "", datesToConvert.join(","), "").subscribe(
            data => {
              if (data && data.length > 0) {
                let sRows = svcSecondRowCtrl.getOptions();
                let fndClmRow = sRows.filter(s => s.value == tempidx.claim_key);
                if (fndClmRow.length > 0) {
                  let desc: string = fndClmRow[0].name;
                  for (let iDT = 0; iDT < data.length; iDT++) {
                    let bc: basecode = data[iDT];
                    desc = desc.replace(bc.code, bc.title);
                  }
                  fndClmRow[0].name = desc;
                }
              }
            },
            error => {
              console.log(JSON.stringify(this.getDomainService().getLastErrors()));
            });

          tempidx["claim_num"] = tempidx.claim_key.substr(0, 10) + "...";
          tempidx["claim_bucket_num"] = tempidx.claim_bucket_key.substr(0, 9) + "...";
          tempidx["status_text"] = MessageService.getStatus(Iceutility.toLong(tempidx["trans_status"]), IceTypes.SourceType.srcStatement);
          if (tempidx.last_message_key.length > 0) {
            let outboundmsg = MessageService.getStatus(Iceutility.toLong(tempidx.last_message_status), IceTypes.SourceType.srcStatement) + " on " + tempidx.last_message_date;
            if (tempidx.last_message_log.length > 0) outboundmsg += ", " + tempidx.last_message_log;
            tempidx["last_message_text"] = outboundmsg;
          }

          let summaryOfClaim = tempidx.claim_date + " Claim No: " + tempidx["claim_num"] + " Claim Bucket No: " + tempidx["claim_bucket_num"]
            + "Status: " + tempidx["status_text"];

          if (tempidx["last_message_text"] != null) {
            summaryOfClaim += " Outbound Message: " + tempidx["last_message_text"];
          }

          secondRows.push({ name: summaryOfClaim, value: tempidx.claim_key, obj: tempidx });
        }

        this.refreshTableData(datasrc);
      }, error => {
        this.refreshTableData([]);
        console.log(JSON.stringify(this.getDomainService().getLastErrors()));
      });
  }

  ////////////////////////////
  // Events
  filterButtonClick(event) {
    switch (this.currentView) {
      case ServiceViews.ViewByClaim: {
        this.searchClaims();
        break;
      }
      case ServiceViews.ViewByPayerBucket: {
        this.searchPayerBucket();
        break;
      }
    }
  }

  resetButtonClick(event) {
    super.resetButtonClick(event);
    // clear the search criteria
    this.currentView = ServiceViews.ViewByClaim;
    this.viewOptions.getFormControl().reset();
    this.viewOptions.getFormControl().setValue(ServiceViews.ViewByClaim);
  }

  onRowBucket(event, typeOfDomain: IceTypes.ACCOUNT_TYPE): void {
    let appSvc = this.getAppService();
    let curDom = appSvc.getCurrentAccount(), curDomType = appSvc.getCurrentAccountType();

    if (ServiceViews.ViewByPayerBucket == this.currentView) {
      let item = <claimbucketindex>event["rowData"];
      this.getRouter().navigate([this.getNavService().buildRoute("accounting/serviceitemcharge/" + item.superbill_charges_key, false)]);
    }
    else {
      let item2 = <claimindex>event["rowData"];
      this.getAccountingService().getBillByService(curDom, curDomType, Iceutility.isdefined(item2.trans_account) ? item2.trans_account : "", typeOfDomain, item2.medical_service_key).subscribe(
        data => {
          if (data != null && data.length > 0) {
            let bills: superbillcharges[] = <superbillcharges[]>data;
            this.getRouter().navigate([this.getNavService().buildRoute("accounting/serviceitemcharge/" + bills[0].superbill_charges_key, false)]);
          }
        },
        error => {
          console.log(error);
        });
    }
  }

  onRowBalance(event, typeOfDomain: IceTypes.ACCOUNT_TYPE): void {
    let appSvc = this.getAppService();
    let curDom = appSvc.getCurrentAccount(), curDomType = appSvc.getCurrentAccountType();

    if (ServiceViews.ViewByPayerBucket == this.currentView) {
      let item = <claimbucketindex>event["rowData"];
      this.getRouter().navigate([this.getNavService().buildRoute("accounting/outstandingbalance/" + item.superbill_charges_key, false)]);
    }
    else {
      let item2 = <claimindex>event["rowData"];
      this.getAccountingService().getBillByService(curDom, curDomType, Iceutility.isdefined(item2.trans_account) ? item2.trans_account : "", typeOfDomain, item2.medical_service_key).subscribe(
        data => {
          if (data != null && data.length > 0) {
            let bills: superbillcharges[] = <superbillcharges[]>data;
            this.getRouter().navigate([this.getNavService().buildRoute("accounting/outstandingbalance/" + bills[0].superbill_charges_key, false)]);
          }
        },
        error => {
          console.log(error);
        });
    }
  }

  onRowEdit(event, typeOfDomain: IceTypes.ACCOUNT_TYPE): void {
    if (event == null) return;

    let appSvc = this.getAppService();
    let curDom = appSvc.getCurrentAccount(), curDomType = appSvc.getCurrentAccountType();

    if (ServiceViews.ViewByClaim == this.currentView) {
      let item = <claimindex>event["rowData"];
      if (item == null) {
        // To do log error
        return;
      }
      this.getAccountingService().getClaimBucket(curDom, curDomType, item.claim_bucket_key).subscribe(
        data => {
          if (data != null && data.length > 0) {
            let clmBucket: claimbucket = data[0];
            this.getRouter().navigate([this.getNavService().buildRoute("accounting/claimsbucket/" + clmBucket.superbill_charges_key, false)]);
          }
        },
        error => {
        }
      );
    }
    else {
      let item = <claimbucketindex>event["rowData"];
      this.getRouter().navigate([this.getNavService().buildRoute("accounting/claimsbucket/" + item.superbill_charges_key, false)]);
    }
  }
}
